module.exports = __webpack_public_path__ + "media/images/home/main/buj-29e6bf7236c186e28c70fef3065a6d7d.png";